import React from "react";
import { createPortal } from "react-dom";
import { QRCodeSVG } from "qrcode.react";
import { nomorPendek, teksUkuran, urlQr } from "@/lib/label";

// Owner 2026-10-19 (requirement 71, v2.11): one thermal label, drawn at its real size (100×150 mm, 203 dpi printer).
// Black on white only, large type. No prices, phone numbers or player names (the server never sends them).
export function LabelTermal({ isi, contoh = false }) {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  return (
    <div data-testid="label-termal" className="box-border flex flex-col overflow-hidden bg-white text-black"
      style={{ width: "100mm", height: "150mm", padding: "4mm", fontFamily: "Inter, Arial, sans-serif" }}>
      <div className="flex items-start justify-between gap-2 border-b-2 border-black pb-2">
        <div className="min-w-0">
          <div style={{ fontSize: "9pt" }} className="font-bold uppercase tracking-wide">{isi.grup_label}{contoh ? " · CONTOH" : ""}</div>
          <div style={{ fontSize: "40pt", lineHeight: 1 }} className="font-mono font-black">{nomorPendek(isi.nomor_spk)}</div>
          <div style={{ fontSize: "10pt" }} className="font-mono">{isi.nomor_spk}</div>
          {isi.nomor_faktur && <div style={{ fontSize: "10pt" }} className="font-mono">{isi.nomor_faktur}</div>}
        </div>
        <QRCodeSVG value={urlQr(origin, isi.nomor_spk)} size={120} level="M" includeMargin={false} style={{ width: "30mm", height: "30mm" }} />
      </div>
      <div className="border-b-2 border-black py-2">
        <div style={{ fontSize: "8pt" }} className="uppercase">Customer</div>
        <div style={{ fontSize: "17pt", lineHeight: 1.15 }} className="font-black">{isi.pelanggan || "—"}</div>
        <div style={{ fontSize: "11pt" }} className="mt-0.5">CS: <b>{isi.cs || "—"}</b></div>
      </div>
      <div className="min-h-0 flex-1 overflow-hidden py-2" style={{ fontSize: "11pt", lineHeight: 1.3 }}>
        {isi.jersey && (
          <div className="mb-1">
            <div className="font-bold">{isi.jersey.tim || "Jersey"} · {isi.jersey.total_pcs} pcs</div>
            {isi.jersey.ukuran?.length > 0 && <div style={{ fontSize: "12pt" }} className="font-mono font-bold">{teksUkuran(isi.jersey.ukuran)}</div>}
          </div>
        )}
        {(isi.rincian || []).map((r) => <div key={r}>• {r}</div>)}
      </div>
      <div className="flex justify-between border-t-2 border-black pt-1.5" style={{ fontSize: "9pt" }}>
        <span>Selesai: <b>{isi.tanggal}</b></span>
        <span className="font-bold">SOQPRINT</span>
      </div>
    </div>
  );
}

// The copy that is printed: its own element directly under <body> (see cssCetak), invisible on screen.
export function LabelCetak({ isi }) {
  if (!isi || typeof document === "undefined") return null;
  return createPortal(<div id="label-cetak" data-testid="label-cetak"><LabelTermal isi={isi} /></div>, document.body);
}
